import React from 'react';
import PropTypes from 'prop-types';
import { Loader, NoInformationFound } from 'Components';
import invoiceDescription from '../../invoice-description';
import InvoicesListMobileAccordion from '../InvoicesListMobileAccordion/InvoicesListMobileAccordion';
import './InvoicesListMobileItemList.css';

const InvoicesListMobileItemList = ({
  data,
  isLoading,
  handleTrExpand,
  setInvoiceMobileState,
  onMenuClick,
  hasAccessToInvoices,
  isGlobalSearch,
  tabs,
  tabIndex,
}) => {
  if (isLoading) {
    return (
      <div className="mobile-item-list__loader">
        <Loader />
      </div>);
  }

  if (data.length === 0) {
    return (
      <div className="invoices-list-mobile__no-info">
        <NoInformationFound
          {...invoiceDescription(
            hasAccessToInvoices, isGlobalSearch,
            tabs[tabIndex],
          )}
        />
      </div>
    );
  }


  return (
    <div className="invoices-list-mobile-item-list">
      {

      data.map((item, i) => (
        <InvoicesListMobileAccordion
          key={item.InvoiceNumber}
          onExpandClick={e => handleTrExpand(e, i)}
          onMenuClick={onMenuClick}
          index={i}
          expanded={item.Expanded}
          setInvoiceMobileState={setInvoiceMobileState}
          data={item}
        />
      ))
    }
    </div>
  );
};
InvoicesListMobileItemList.propTypes = {
  handleTrExpand: PropTypes.func,
  isLoading: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.shape({})),
  setInvoiceMobileState: PropTypes.func,
  onMenuClick: PropTypes.func,
  hasAccessToInvoices: PropTypes.bool,
  isGlobalSearch: PropTypes.bool,
  tabs: PropTypes.arrayOf(PropTypes.string),
  tabIndex: PropTypes.number,
};
export default InvoicesListMobileItemList;



// WEBPACK FOOTER //
// ./src/containers/Invoices/InvoicesList/InvoicesListMobile/InvoicesListMobileItemList/InvoicesListMobileItemList.jsx